export class SessionFile {
    id: number;
    name: string;
    createdOn: Date;

    constructor(data?: Partial<SessionFile>) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.createdOn = data?.createdOn ? new Date(data.createdOn) : new Date();
    }
}